"use client";

import { LeaderboardPlayer } from "@/types/leaderboards";
import { convertLetters } from "@/utils/letterConversion";
import LeaderboardRow from "./LeaderboardRow";

interface LeaderboardTableProps {
    players: LeaderboardPlayer[];
    isLoading?: boolean;
    emptyMessage?: string;
}

const LeaderboardTable: React.FC<LeaderboardTableProps> = ({
    players,
    isLoading = false,
    emptyMessage = "No players found.",
}) => {
    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-10">
                <p className="font-prviking text-brand animate-pulse text-2xl">
                    {convertLetters("Loading")}
                </p>
            </div>
        );
    }

    if (!players.length) {
        return (
            <div className="flex items-center justify-center py-10">
                <p className="font-prviking text-brand text-2xl">
                    {convertLetters(emptyMessage)}
                </p>
            </div>
        );
    }

    return (
        <div className="border-brand w-full overflow-hidden rounded-xl border bg-zinc-950/75 shadow-xl">
            <div className="border-b border-zinc-700 bg-zinc-900/90 px-4 py-2 sm:px-6">
                <div className="font-prviking text-brand grid grid-cols-[64px_1fr_auto] gap-3 text-sm">
                    <span>{convertLetters("Rank")}</span>
                    <span>{convertLetters("Player")}</span>
                    <span>{convertLetters("Value")}</span>
                </div>
            </div>
            <div className="divide-y divide-zinc-800">
                {players.map((player, index) => (
                    <LeaderboardRow
                        key={player.playerId}
                        player={player}
                        rank={index + 1}
                    />
                ))}
            </div>
        </div>
    );
};

export default LeaderboardTable;
